
const initFAQDropDown = function () {
  const faqDropdownList = document.querySelectorAll('.faq__heading');

  faqDropdownList.forEach((item) => {
    item.addEventListener('click', function () {
      const dropdownArrowElement = item.querySelector('.faq__dropdown');
      const dropdownText = item.nextElementSibling;
      dropdownArrowElement.classList.toggle('faq__dropdown--dropped');
      dropdownText.classList.toggle('faq__content--show');
    }, true);
  });
};

window.initFAQDropDown = initFAQDropDown;